import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Button, Modal, message } from 'antd'

import { req_page_rns_registerSpace, req_add_rns_registerSpace } from '../../api'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { usrRole, _uuid } from '../../utils/dataUtil'

import QrcodeModal from './qrcode-modal'
import SpaceAddModal from './space-add-modal'
import FootprintModal from './footprint-modal'

class RegisterSpace extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        loading: false,
        userLevel: 'NORMAL',
        item: {},

        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: '',

        isShowAddModal: false,
        isShowQrcodeModal: false,
        isShowFootprintModal: false
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, role, userCode } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_rns_registerSpace(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_add_item = async (registerSpace) => {
        const { token, userCode } = this.props.user
        registerSpace.RecordCreator = userCode
        const result = await req_add_rns_registerSpace(registerSpace, token)
        // 3.根據結果提示/更新列表
        if (result.status === 'success') {
            // 3.1 結果提示
            message.success('增加成功')
            this.form_add.current.resetFields()
            this.setState({ isShowAddModal: false })
            // 3.2 更新列表
            this.api_page_items(this.current)
        } else {
            message.success('增加失敗')
        }

        //console.log(result);
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '地點',
                dataIndex: 'SpaceName',
                width: 60,
            },
            {
                title: '',
                dataIndex: '',
                width: 60,
                render: (item) => {
                    const { Uid } = item
                    return (
                        <>
                            <Button type='dashed' size='small' style={{ color: 'Green' }} onClick={() => this.handle_show_ui_footprint(item)}><i className="fas fa-user-friends"></i><span style={{ marginLeft: '5px' }}>人次</span></Button>
                            <Button type='dashed' size='small' style={{ color: 'Green' }} onClick={() => this.handle_show_ui_qrcode(Uid)}><i className="fas fa-qrcode"></i><span style={{ marginLeft: '5px' }}>條碼</span></Button>
                        </>
                    )
                },
            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }


    handle_show_ui_qrcode = (code) => {
        this.setState({ isShowQrcodeModal: true })
        this.code = code
    }

    handle_show_ui_footprint = (code) => {
        this.setState({ isShowFootprintModal: true })
        this.spacekey = code
    }


    handle_show_ui_add = () => {
        this.setState({ isShowAddModal: true })
    }

    handle_process_add = () => {
        this.form_add.current.validateFields().then(values => {
            const {SpaceName }= values
            const registerSpace = {
                Uid: _uuid(),
                SpaceName: SpaceName,
                RecordCreator: ''
            }
            console.log(registerSpace)
            this.api_add_item(registerSpace)
        }).catch(error => {
            console.log(error.errorFields);
        });
    }

    /////////////////////////////////////////////////////////////     

    render() {
        const qc = this.code
        const spacekey  = this.spacekey
        const { loading, items, pagination, isShowQrcodeModal, isShowAddModal, isShowFootprintModal } = this.state
        const title = (
            <>
                <Button type='primary' onClick={this.handle_show_ui_add}><i className="fas fa-plus-circle"></i> <span style={{ marginLeft: '5px' }}>增加</span></Button>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    title="增加地點"
                    visible={isShowAddModal}
                    onOk={this.handle_process_add}
                    onCancel={() => {
                        this.setState({ isShowAddModal: false })
                    }}
                >
                    <SpaceAddModal
                        setForm={(form) => this.form_add = form}
                    />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="二維碼"
                    visible={isShowQrcodeModal}
                    width={300}
                    onOk={() => {
                        this.setState({ isShowQrcodeModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isShowQrcodeModal: false })
                    }}
                >
                    <QrcodeModal qc={qc} />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="到訪清單"
                    visible={isShowFootprintModal}
                    width={400}
                    onOk={() => {
                        this.setState({ isShowFootprintModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isShowFootprintModal: false })
                    }}
                >
                    <FootprintModal Space={spacekey} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(RegisterSpace)